export const Status = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  PENDING: 'PENDING',
};

export const DOCUMENT_TYPES = [
  {
    id: 1,
    name: 'DNI',
  },
  {
    id: 2,
    name: 'L.C.',
  },
  {
    id: 3,
    name: 'L.E.',
  },
];

export const GENDER_TYPES = [
  {
    id: 1,
    name: 'Masculino',
  },
  {
    id: 2,
    name: 'Femenino',
  },
  {
    id: 3,
    name: 'Otro',
  },
];

export const PAYMENTMETHODS = [
  { name: "Credit Card", url: 'https://cdn-icons-png.flaticon.com/512/11041/11041055.png' },
  { name: "Transfer", url: 'https://cdn-icons-png.flaticon.com/512/196/196578.png' },
];